var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
// css
import "./file-upload-component.scss";
// components
import FileProgress from "./components/FileProgress";
import { ToastModal } from "../common";
import aifPmsDi from "@mainDi/features/AIF-PMS/servicelocator";
import { uploadProgressApi } from "../../helpers";
import { AifPmsDraftUrl } from "@adapters/infrastructures/urlConfig/Markets/aifPmsURL";
import { TransactionTypeEnum } from "@domains/features/Markets/AIF-PMS/entities/GlobalEntity";
var FileUploadComponent = function (_a) {
    //
    var _b;
    var fileSize = _a.fileSize;
    var _c = __read(useState(null), 2), error = _c[0], setError = _c[1];
    var _d = __read(useState(false), 2), visible = _d[0], setVisible = _d[1];
    var _e = __read(useState(null), 2), uploader = _e[0], setUploader = _e[1];
    var _f = __read(useState(""), 2), message = _f[0], setMessage = _f[1];
    var _g = __read(useState(null), 2), activePreview = _g[0], setActivePreview = _g[1];
    var _h = useSelector(function (state) { return state.markets.AifPms; }), subCategoryId = _h.subCategoryId, transactionId = _h.transactionId, clientDetails = _h.clientDetails;
    var activeTypeList = useSelector(function (state) { return state.markets.global; }).activeTypeList;
    var _j = useSelector(function (state) { return state.markets.payment; }), uploadDeclaration = _j.uploadDeclaration, purchase = _j.purchase, topup = _j.topup;
    var isPurchaseDocs = (activeTypeList === null || activeTypeList === void 0 ? void 0 : activeTypeList.trx_type) == TransactionTypeEnum.Redeem ||
        (activeTypeList === null || activeTypeList === void 0 ? void 0 : activeTypeList.trx_type) == TransactionTypeEnum.TransferIn;
    useEffect(function () {
        if (transactionId > 0) {
            aifPmsDi.draft
                .getDraftOrderDeclaration({
                trx_id: transactionId !== null && transactionId !== void 0 ? transactionId : 0,
            })
                .then(function (response) {
                var _a;
                var files = (_a = response.data) === null || _a === void 0 ? void 0 : _a.map(function (item, index) {
                    return __assign(__assign({}, item), { file: {
                            name: item.filename,
                        }, imageUrl: "", progress: 100 });
                });
                aifPmsDi.payment.updateUploadDeclarationValueProp(files);
            });
        }
    }, []);
    var supportedFormats = [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "application/pdf",
    ];
    function checkPreValidation(e) {
        var _a, _b;
        if (!isPurchaseDocs) {
            if ((activeTypeList === null || activeTypeList === void 0 ? void 0 : activeTypeList.trx_type) === TransactionTypeEnum.Purchase) {
                if (!purchase.amount.trim() || !((_a = purchase.formNo) === null || _a === void 0 ? void 0 : _a.trim())) {
                    setVisible(true);
                    setMessage("You can upload the file only after entering the amount and form number");
                    handleScrollToTop();
                    //@ts-ignore
                    e.target.value = "";
                    return;
                }
            }
            else if ((activeTypeList === null || activeTypeList === void 0 ? void 0 : activeTypeList.trx_type) === TransactionTypeEnum.TopUp) {
                if (!topup.amount.trim() || !((_b = topup.folio) === null || _b === void 0 ? void 0 : _b.trim())) {
                    setVisible(true);
                    setMessage("You can upload the file only after entering the amount and folio number");
                    handleScrollToTop();
                    //@ts-ignore
                    e.target.value = "";
                    return;
                }
            }
        }
    }
    var handleDrop = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var fileLength, selectedFiles, maxSizeBytes, hasError, readFilePromises, filesWithData, fileArray, uploadDataArray, uploadData_1, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    checkPreValidation(e);
                    fileLength = e.dataTransfer.files.length;
                    selectedFiles = Array.from(e.dataTransfer.files);
                    if ((selectedFiles === null || selectedFiles === void 0 ? void 0 : selectedFiles.length) === 0)
                        return [2 /*return*/];
                    maxSizeBytes = fileSize * 1024 * 1024;
                    hasError = false;
                    setError(null);
                    readFilePromises = [];
                    selectedFiles.forEach(function (selectedFile) {
                        if (!supportedFormats.includes(selectedFile.type)) {
                            setError("Unsupported file format. Supported formats are JPEG, PNG, JPG, and PDF.");
                            hasError = true;
                            return;
                        }
                        if (selectedFile.size > maxSizeBytes) {
                            setError("File size exceeds ".concat(fileSize, " MB."));
                            hasError = true;
                            return;
                        }
                        var reader = new FileReader();
                        var fileReadPromise = new Promise(function (resolve) {
                            reader.onload = function () {
                                resolve({
                                    file: selectedFile,
                                    imageUrl: reader.result,
                                    progress: 0,
                                    failure: false,
                                    declarationId: undefined,
                                });
                            };
                        });
                        reader.readAsDataURL(selectedFile);
                        readFilePromises.push(fileReadPromise);
                    });
                    if (hasError)
                        return [2 /*return*/];
                    e.dataTransfer.clearData();
                    return [4 /*yield*/, Promise.all(readFilePromises)];
                case 1:
                    filesWithData = _a.sent();
                    fileArray = uploadDeclaration || [];
                    fileArray.push.apply(fileArray, __spreadArray([], __read(filesWithData), false));
                    aifPmsDi.payment.updateUploadDeclarationValueProp(fileArray);
                    if (isPurchaseDocs)
                        return [2 /*return*/];
                    uploadDataArray = filesWithData.map(function (item) {
                        var _a, _b, _c;
                        return ({
                            categoryCode: subCategoryId,
                            trxId: transactionId !== null && transactionId !== void 0 ? transactionId : 0,
                            fileData: (_a = item.imageUrl) === null || _a === void 0 ? void 0 : _a.split(",")[1],
                            filename: (_b = item.file.name) !== null && _b !== void 0 ? _b : "",
                            filetype: (_c = item.imageUrl) === null || _c === void 0 ? void 0 : _c.split(",")[0],
                            uccCode: clientDetails.ucccode,
                        });
                    });
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    uploadData_1 = __spreadArray([], __read(uploadDeclaration), false);
                    return [4 /*yield*/, Promise.all(uploadDataArray.map(function (file, index) { return __awaiter(void 0, void 0, void 0, function () {
                            var response;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, uploadProgressApi(file, AifPmsDraftUrl.saveDraftDocs, function (fileId, progress, abort) {
                                            if (fileLength > 1) {
                                                var matchedFiles = uploadDeclaration.filter(function (item) {
                                                    return uploadDataArray.some(function (info) { return info.filename === item.file.name; });
                                                });
                                                var unmatchedFiles = uploadDeclaration.filter(function (item) {
                                                    return !uploadDataArray.some(function (info) { return info.filename === item.file.name; });
                                                });
                                                var filterData = matchedFiles.map(function (item) {
                                                    return __assign(__assign({}, item), { failure: false, progress: Number(progress.upload).toFixed(0), _id: index + 1 });
                                                });
                                                uploadData_1 = __spreadArray(__spreadArray([], __read(unmatchedFiles), false), __read(filterData), false);
                                            }
                                            else {
                                                uploadData_1 = uploadDeclaration.map(function (item) {
                                                    var _a;
                                                    return ((_a = item === null || item === void 0 ? void 0 : item.file) === null || _a === void 0 ? void 0 : _a.name) === fileId
                                                        ? __assign(__assign({}, item), { failure: false, progress: Number(progress.upload).toFixed(0), _id: index + 1 }) : item;
                                                });
                                            }
                                            setUploader({ removeFile: abort });
                                            aifPmsDi.payment.updateUploadDeclarationValueProp(__spreadArray([], __read(uploadData_1), false));
                                        }, function (filename, error) {
                                            if (fileLength > 1) {
                                                uploadDeclaration[index].failure = true;
                                                uploadDeclaration[index].progress = Number(error);
                                            }
                                            else {
                                                uploadData_1 = uploadDeclaration.map(function (item) {
                                                    var _a;
                                                    return ((_a = item === null || item === void 0 ? void 0 : item.file) === null || _a === void 0 ? void 0 : _a.name) === filename
                                                        ? __assign(__assign({}, item), { failure: true, progress: Number(error) }) : item;
                                                });
                                            }
                                            aifPmsDi.payment.updateUploadDeclarationValueProp(__spreadArray([], __read(uploadData_1), false));
                                        }, function (filename, result) {
                                            if (fileLength > 1) {
                                                uploadDeclaration[index].declarationId =
                                                    result.data.declarationId;
                                                uploadDeclaration[index].progress = 100;
                                                uploadDeclaration[index].failure = false;
                                            }
                                            else {
                                                uploadData_1 = uploadDeclaration.map(function (item) {
                                                    var _a;
                                                    return ((_a = item === null || item === void 0 ? void 0 : item.file) === null || _a === void 0 ? void 0 : _a.name) === filename
                                                        ? __assign(__assign({}, item), { declarationId: result.data.declarationId, failure: false, progress: 100 }) : item;
                                                });
                                            }
                                            aifPmsDi.payment.updateUploadDeclarationValueProp(__spreadArray([], __read(uploadData_1), false));
                                        }, function (filename) {
                                            uploadData_1 = uploadDeclaration.filter(function (item) {
                                                var _a;
                                                return ((_a = item === null || item === void 0 ? void 0 : item.file) === null || _a === void 0 ? void 0 : _a.name) !== filename;
                                            });
                                            aifPmsDi.payment.updateUploadDeclarationValueProp(__spreadArray([], __read(uploadData_1), false));
                                        })];
                                    case 1:
                                        response = (_a.sent()).response;
                                        return [2 /*return*/, response];
                                }
                            });
                        }); }))];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    console.log("Error in file upload", error_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleScrollToTop = function () {
        var element = document.querySelector(".width-375");
        if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };
    var duplicateFiles = [];
    var handleFileSelect = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var fileLength, selectedFiles, maxSizeBytes, hasError, existingFiles, readFilePromises, filesWithData, fileArray, uploadDataArray, uploadData_2, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    checkPreValidation(e);
                    fileLength = e.target.files.length;
                    selectedFiles = Array.from(e.target.files);
                    if ((selectedFiles === null || selectedFiles === void 0 ? void 0 : selectedFiles.length) === 0)
                        return [2 /*return*/];
                    maxSizeBytes = fileSize * 1024 * 1024;
                    hasError = false;
                    setError(null);
                    existingFiles = new Set((uploadDeclaration === null || uploadDeclaration === void 0 ? void 0 : uploadDeclaration.map(function (file) { var _a; return (_a = file === null || file === void 0 ? void 0 : file.file) === null || _a === void 0 ? void 0 : _a.name; })) || []);
                    readFilePromises = [];
                    selectedFiles.forEach(function (selectedFile) {
                        if (existingFiles.has(selectedFile.name)) {
                            duplicateFiles.push(selectedFile.name);
                            hasError = true;
                            return;
                        }
                        if (!supportedFormats.includes(selectedFile.type)) {
                            setError("Unsupported file format. Supported formats are JPEG, PNG, JPG, and PDF.");
                            hasError = true;
                            return;
                        }
                        if (selectedFile.size > maxSizeBytes) {
                            setError("File size exceeds ".concat(fileSize, " MB."));
                            hasError = true;
                            return;
                        }
                        existingFiles.add(selectedFile === null || selectedFile === void 0 ? void 0 : selectedFile.name);
                        var reader = new FileReader();
                        var fileReadPromise = new Promise(function (resolve) {
                            reader.onload = function () {
                                resolve({
                                    file: selectedFile,
                                    imageUrl: reader.result,
                                    progress: 0,
                                    failure: false,
                                    declarationId: undefined,
                                });
                            };
                        });
                        reader.readAsDataURL(selectedFile);
                        readFilePromises.push(fileReadPromise);
                    });
                    if (duplicateFiles.length > 0) {
                        setError("Duplicate files selected: ".concat(duplicateFiles.join(", "), ". Please select different files."));
                        return [2 /*return*/];
                    }
                    if (hasError)
                        return [2 /*return*/];
                    e.target.value = "";
                    return [4 /*yield*/, Promise.all(readFilePromises)];
                case 1:
                    filesWithData = _a.sent();
                    fileArray = uploadDeclaration || [];
                    fileArray.push.apply(fileArray, __spreadArray([], __read(filesWithData), false));
                    aifPmsDi.payment.updateUploadDeclarationValueProp(fileArray);
                    if (isPurchaseDocs)
                        return [2 /*return*/];
                    uploadDataArray = filesWithData.map(function (item) {
                        var _a, _b, _c;
                        return ({
                            categoryCode: subCategoryId,
                            trxId: transactionId !== null && transactionId !== void 0 ? transactionId : 0,
                            fileData: (_a = item === null || item === void 0 ? void 0 : item.imageUrl) === null || _a === void 0 ? void 0 : _a.split(",")[1],
                            filename: (_b = item === null || item === void 0 ? void 0 : item.file.name) !== null && _b !== void 0 ? _b : "",
                            filetype: (_c = item === null || item === void 0 ? void 0 : item.imageUrl) === null || _c === void 0 ? void 0 : _c.split(",")[0],
                            uccCode: clientDetails.ucccode,
                        });
                    });
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    uploadData_2 = __spreadArray([], __read(uploadDeclaration), false);
                    return [4 /*yield*/, Promise.all(uploadDataArray.map(function (file, index) { return __awaiter(void 0, void 0, void 0, function () {
                            var response;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, uploadProgressApi(file, AifPmsDraftUrl.saveDraftDocs, function (fileId, progress, abort) {
                                            if (fileLength > 1) {
                                                var matchedFiles = uploadDeclaration.filter(function (item) {
                                                    return uploadDataArray.some(function (info) { return info.filename === item.file.name; });
                                                });
                                                var unmatchedFiles = uploadDeclaration.filter(function (item) {
                                                    return !uploadDataArray.some(function (info) { return info.filename === item.file.name; });
                                                });
                                                var filterData = matchedFiles.map(function (item) {
                                                    return __assign(__assign({}, item), { failure: false, progress: Number(progress.upload).toFixed(0), _id: index + 1 });
                                                });
                                                uploadData_2 = __spreadArray(__spreadArray([], __read(unmatchedFiles), false), __read(filterData), false);
                                            }
                                            else {
                                                uploadData_2 = uploadDeclaration.map(function (item) {
                                                    var _a;
                                                    return ((_a = item === null || item === void 0 ? void 0 : item.file) === null || _a === void 0 ? void 0 : _a.name) === fileId
                                                        ? __assign(__assign({}, item), { failure: false, progress: Number(progress.upload).toFixed(0), _id: index + 1 }) : item;
                                                });
                                            }
                                            setUploader({ removeFile: abort });
                                            aifPmsDi.payment.updateUploadDeclarationValueProp(__spreadArray([], __read(uploadData_2), false));
                                        }, function (filename, error) {
                                            if (fileLength > 1) {
                                                uploadDeclaration[index].failure = true;
                                                uploadDeclaration[index].progress = Number(error);
                                            }
                                            else {
                                                uploadData_2 = uploadDeclaration.map(function (item) {
                                                    var _a;
                                                    return ((_a = item === null || item === void 0 ? void 0 : item.file) === null || _a === void 0 ? void 0 : _a.name) === filename
                                                        ? __assign(__assign({}, item), { failure: true, progress: Number(error) }) : item;
                                                });
                                            }
                                            aifPmsDi.payment.updateUploadDeclarationValueProp(__spreadArray([], __read(uploadData_2), false));
                                        }, function (filename, result) {
                                            if (fileLength > 1) {
                                                uploadDeclaration[index].declarationId =
                                                    result.data.declarationId;
                                                uploadDeclaration[index].progress = 100;
                                                uploadDeclaration[index].failure = false;
                                            }
                                            else {
                                                uploadData_2 = uploadDeclaration.map(function (item) {
                                                    var _a;
                                                    return ((_a = item === null || item === void 0 ? void 0 : item.file) === null || _a === void 0 ? void 0 : _a.name) === filename
                                                        ? __assign(__assign({}, item), { declarationId: result.data.declarationId, failure: false, progress: 100 }) : item;
                                                });
                                            }
                                            aifPmsDi.payment.updateUploadDeclarationValueProp(__spreadArray([], __read(uploadData_2), false));
                                        }, function (filename) {
                                            uploadData_2 = uploadDeclaration.filter(function (item) {
                                                var _a;
                                                return ((_a = item === null || item === void 0 ? void 0 : item.file) === null || _a === void 0 ? void 0 : _a.name) !== filename;
                                            });
                                            aifPmsDi.payment.updateUploadDeclarationValueProp(__spreadArray([], __read(uploadData_2), false));
                                        })];
                                    case 1:
                                        response = (_a.sent()).response;
                                        return [2 /*return*/, response];
                                }
                            });
                        }); }))];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    error_2 = _a.sent();
                    console.log("Error in file upload", error_2);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var onClickDelete = function (item) {
        var _a;
        setError("");
        if (isPurchaseDocs || (item === null || item === void 0 ? void 0 : item.declarationId) == undefined || item.failure) {
            if ((item === null || item === void 0 ? void 0 : item.progress) <= 99 && (uploader === null || uploader === void 0 ? void 0 : uploader.removeFile)) {
                uploader === null || uploader === void 0 ? void 0 : uploader.removeFile((_a = item === null || item === void 0 ? void 0 : item.file) === null || _a === void 0 ? void 0 : _a.name);
            }
        }
        else {
            aifPmsDi.draft
                .deletedDraftDocs({
                declarationId: (item === null || item === void 0 ? void 0 : item.declarationId) || 0,
            })
                .then(function (data) {
                var files = uploadDeclaration.filter(function (_item) { return _item.declarationId !== item.declarationId; });
                aifPmsDi.payment.updateUploadDeclarationValueProp(files);
            })
                .catch(function (error) {
                //
            });
        }
    };
    var onClickPreview = function (item, index) {
        if (item.imageUrl == "") {
            aifPmsDi.draft
                .getPreviewDocs({ declarationId: item.declarationId })
                .then(function (response) {
                var updatedFiles = __spreadArray([], __read(uploadDeclaration), false);
                var fileExtension = item === null || item === void 0 ? void 0 : item.filename.split(".").pop().toLowerCase();
                if (["png", "jpg", "jpeg", "gif"].includes(fileExtension)) {
                    updatedFiles[index] = __assign(__assign({}, updatedFiles[index]), { imageUrl: "data:image/".concat(fileExtension, ";base64,").concat(response.data.fileData), declarationId: response.data.declarationId });
                }
                else if (fileExtension === "pdf") {
                    updatedFiles[index] = __assign(__assign({}, updatedFiles[index]), { imageUrl: "data:application/pdf;base64,".concat(response.data.fileData), declarationId: response.data.declarationId });
                }
                else {
                    updatedFiles[index] = __assign(__assign({}, updatedFiles[index]), { imageUrl: response.data.fileType + "," + response.data.filePath, declarationId: response.data.declarationId });
                }
                aifPmsDi.payment.updateUploadDeclarationValueProp(updatedFiles);
            })
                .catch(function (error) {
                //
            });
        }
    };
    var customProgress = (activeTypeList === null || activeTypeList === void 0 ? void 0 : activeTypeList.trx_type) == TransactionTypeEnum.Purchase ||
        (activeTypeList === null || activeTypeList === void 0 ? void 0 : activeTypeList.trx_type) == TransactionTypeEnum.TopUp
        ? 0
        : 100;
    var handlePreview = function (fileName) {
        setActivePreview(function (prev) { return (prev === fileName ? null : fileName); });
    };
    console.log(error, "");
    return (React.createElement("div", { className: "file-upload-container position-relative" },
        React.createElement("div", { className: "file-drop-zone", onDrop: handleDrop, onDragOver: function (e) { return e.preventDefault(); } },
            React.createElement("div", { className: "upload-icon" },
                React.createElement("i", { className: "edel-icon-upload-file" })),
            React.createElement("p", { className: "DMSans_13_400" }, "Drag and drop your files here"),
            error ? (React.createElement("div", { className: "error DMSansNormal_12_400" }, error)) : (React.createElement("div", { className: "text-manatee DMsanR_10_400" }, "Files Supported: JPEG, PNG, JPG, PDF (Max file size - ".concat(fileSize, "MB)"))),
            React.createElement("label", { className: "browse-button DMSanM_14_500" },
                "or Browse Files",
                React.createElement("input", { type: "file", multiple: true, onChange: handleFileSelect, accept: "image/jpeg, image/png, image/jpg, application/pdf" }))),
        (uploadDeclaration === null || uploadDeclaration === void 0 ? void 0 : uploadDeclaration.filter(function (item) { return item !== undefined; }).length) > 0 && (React.createElement("div", { className: "mt-20 d-flex flex-column gap-3" }, (_b = uploadDeclaration === null || uploadDeclaration === void 0 ? void 0 : uploadDeclaration.filter(function (item) { return item !== undefined; })) === null || _b === void 0 ? void 0 : _b.map(function (item, index) {
            var _a, _b, _c, _d;
            return (React.createElement(FileProgress, { key: index, fileName: (_a = item === null || item === void 0 ? void 0 : item.file) === null || _a === void 0 ? void 0 : _a.name, progress: (item === null || item === void 0 ? void 0 : item.progress) || customProgress, size: ((_b = item === null || item === void 0 ? void 0 : item.fileSize) === null || _b === void 0 ? void 0 : _b.toString())
                    ? (_c = item === null || item === void 0 ? void 0 : item.fileSize) === null || _c === void 0 ? void 0 : _c.toString()
                    : " ".concat((Number(((_d = item === null || item === void 0 ? void 0 : item.file) === null || _d === void 0 ? void 0 : _d.size) || 0) /
                        1024 /
                        1024).toFixed(2), "MB"), imagePreview: item === null || item === void 0 ? void 0 : item.imageUrl, onClickClose: function () { return onClickDelete(item); }, onClickPreview: function () {
                    var _a;
                    onClickPreview(item, index);
                    handlePreview((_a = item === null || item === void 0 ? void 0 : item.file) === null || _a === void 0 ? void 0 : _a.name);
                }, failure: item === null || item === void 0 ? void 0 : item.failure, activePreview: activePreview }));
        }))),
        React.createElement(ToastModal, { visible: visible, setVisible: setVisible, message: message, isError: true })));
};
export default FileUploadComponent;
